import Types from "./types";

const setDetails = data => ({
    type: Types.SET_DETAILS,
    data
});

const setStepDetails = (data, stepName) => ({
    type: Types.SET_STEP_DETAILS,
    data,
    stepName
});

const setActiveAccordionStepIndex = (index) => ({
    type: Types.SET_ACCORDION_ACTIVE_STEP_INDEX,
    payload: index
});

const setFormActiveScreen = (screenType) => ({
    type: Types.SET_FORM_ACTIVE_SCREEN,
    payload: screenType
});

const resetPdiLeadData = () => ({
    type: Types.RESET_PDI_LEAD_DATA
});

const setCarTypePdiLead = (newCarPdiLead) => ({
    type: Types.SET_CAR_TYPE_PDI_LEAD,
    newCarPdiLead
});

export {
    setDetails,
    setStepDetails,
    setActiveAccordionStepIndex,
    setFormActiveScreen,
    resetPdiLeadData,
    setCarTypePdiLead
};
